import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';
import PasswordStrength from '../../components/password-strength/password-strength';
import Input from '../../components/input/input';
import Validation from '../../components/validation/validation';

const getErrorMessage = (errors, prop) => {
    let errorMessage = null;
    errors.forEach(error => {
        if (error.property === prop) {
            errorMessage = error.messages.join(';');
        }
    });
    return errorMessage;
};

class ChangePasswordPage extends React.PureComponent {
    state = {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
    };

    setValue = (prop) => (value) => {
        this.setState({
            [prop]: value
        });
        if (prop === 'oldPassword') {
            if (this.hasOldPasswordError) {
                this.form.hideError('OldPassword');
                this.hasOldPasswordError = false;
            }
        }
        if (prop === 'newPassword') {
            if (this.hasNewPasswordError) {
                this.form.hideError('NewPassword');
                this.hasNewPasswordError = false;
            }
        }
    };

    componentDidMount() {
        if (this.props.model.errors && this.props.model.errors.length > 0 && this.form) {
            const oldPasswordMessage = getErrorMessage(this.props.model.errors, 'OldPassword');
            const newPasswordMessage = getErrorMessage(this.props.model.errors, 'NewPassword');
            if (oldPasswordMessage) {
                this.form.showError('OldPassword', () => oldPasswordMessage);
                this.hasOldPasswordError = true;
            }
            if (newPasswordMessage) {
                this.form.showError('NewPassword', () => newPasswordMessage);
                this.hasNewPasswordError = true;
            }
            this.form.validateAll();
        }
    }

    render() {
        return (
            <AuthWrapper
                heading="Change Password"
                goBackUrl={this.props.model.returnUrl}
            >
                <Validation.Form
                    method="post"
                    action="ChangePassword"
                    name="ChangePassword"
                    ref={(c) => { this.form = c; }}
                >
                    <input type="hidden" name="ReturnUrl" value={this.props.model.returnUrl} />
                    <input type="hidden" name="AutoRedirect" value={this.props.model.autoRedirect} />
                    <input type="hidden" name="Email" value={this.props.model.email} />
                    <section className="sten-content__section">
                        <p>Enter your old password and confirm new password in order to reset it.</p>
                    </section>
                    <section className="sten-content__section">
                        <Validation.Wrapper
                            validations={{
                                required: true,
                                minLength: 8,
                                maxLength: 30,
                                containsCharTypes: {
                                    types: ['lowercase', 'uppercase', 'digits', 'special'],
                                    length: 3
                                },
                                strength: {
                                    totalScore: 60,
                                    diffChars: 5
                                }
                            }}
                        >
                            <Input
                                autoFocus
                                name="OldPassword"
                                className="sten-input--sm"
                                type="password"
                                id="password"
                                placeholder="Old Password"
                                value={this.state.oldPassword}
                                onChange={this.setValue('oldPassword')}
                                showKeyboard
                            />
                        </Validation.Wrapper>
                    </section>
                    <section className="sten-content__section">
                        <Validation.Wrapper
                            validations={{
                                required: true,
                                minLength: 8,
                                maxLength: 30,
                                containsCharTypes: {
                                    types: ['lowercase', 'uppercase', 'digits', 'special'],
                                    length: 3
                                },
                                strength: {
                                    totalScore: 60,
                                    diffChars: 5
                                }
                            }}
                        >
                            <Input
                                name="NewPassword"
                                className="sten-input--sm"
                                type="password"
                                id="newPassword"
                                placeholder="New Password"
                                value={this.state.newPassword}
                                onChange={this.setValue('newPassword')}
                                showKeyboard
                            />
                        </Validation.Wrapper>
                        <PasswordStrength value={this.state.newPassword} />
                    </section>
                    <section className="sten-content__section">
                        <Validation.Wrapper
                            validations={{
                                required: true,
                                equalAs: { prop: 'NewPassword', label: 'New password' }
                            }}
                        >
                            <Input
                                name="ConfirmNewPassword"
                                className="sten-input--sm"
                                type="password"
                                id="confirmNewPassword"
                                placeholder="Confirm New Password"
                                value={this.state.confirmNewPassword}
                                onChange={this.setValue('confirmNewPassword')}
                                showKeyboard
                            />
                        </Validation.Wrapper>
                    </section>
                    <div className="sten-content__separator" />
                    <section className="sten-content__section">
                        <Validation.Button className="btn btn--primary btn--sm col-24">
                            Change Password
                        </Validation.Button>
                    </section>
                    <input name="__RequestVerificationToken" type="hidden" value={this.props.token} />
                </Validation.Form>
            </AuthWrapper>
        );
    }
}

ChangePasswordPage.propTypes = {
    model: PropTypes.objectOf(PropTypes.any).isRequired,
    token: PropTypes.string.isRequired
};

export default ChangePasswordPage;
